var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('UseSocialRoute',{scopedSlots:_vm._u([{key:"default",fn:function(ref){
var title = ref.title;
return [_c('SdsMobileHeader',{attrs:{"titleOverride":title},scopedSlots:_vm._u([(_vm.isSocialProfileRoute)?{key:"bottom",fn:function(){return [_c('div')]},proxy:true}:null],null,true)})]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }